import React from 'react';

export const VaultSkeleton = () => {
  return (
    <div className="animate-pulse rounded-2xl p-4 bg-white/10 dark:bg-white/5 backdrop-blur-md border border-white/10">
      <div className="h-6 bg-white/20 rounded w-3/4 mb-3"></div>
      <div className="h-4 bg-white/10 rounded w-full mb-2"></div>
      <div className="h-4 bg-white/10 rounded w-5/6 mb-4"></div>
      <div className="flex justify-between">
        <div className="h-5 bg-white/20 rounded w-1/3"></div>
        <div className="h-4 bg-white/10 rounded w-1/4"></div>
      </div>
    </div>
  );
};
